import { get as getFromPdo } from '../../../application/pageDataObject'
import { nodes } from '../../../utils/dom'
import { SELECTORS } from '../../../config/preRenderedSelectorsConfig'
import { getIsDesktop, getIsMobile, getIsTablet, getIsTabletInPortrait } from '../../../utils/ua'

const adsConfig = getFromPdo('config.ads', require('../../config/adsConfig'))
const APS_PUBLISHER_ID = '3777'
const US_COUNTRY_CODE = 'US'

export const isCountryCodeUnitedStates = countryCode => countryCode === US_COUNTRY_CODE

const getDimensionsArray = dimensions => {
  let res = dimensions[Object.keys(dimensions)[0]]
  if (getIsDesktop() && dimensions.desktop) {
    res = dimensions.desktop
  } else if (getIsMobile() && dimensions.mobile) {
    res = dimensions.mobile
  } else if (getIsTablet() && dimensions.landscapeTablet) {
    res = dimensions.landscapeTablet
  } else if (getIsTabletInPortrait() && dimensions.portraitTablet) {
    res = dimensions.portraitTablet
  }
  return res.map(x => [x.width, x.height])
}

const initAmazonHeaderBidder = () => {
  const adElements = nodes(SELECTORS.AD)
  const { ads_conf } = getFromPdo('page', null)
  const adIds = [...adElements]
    .map(element => element.dataset.slotId)
    .filter(id => adsConfig.slot[id])
  const slotConfigs = adIds.map(id => ({ id: id, config: adsConfig.slot[id] }))
  const slots = slotConfigs.map(entry => ({
    slotID: entry.config.doubleClick.slotDivId,
    slotName: `${ads_conf.ad_unit_path_prefix}/${entry.id}`,
    sizes: getDimensionsArray(entry.config.doubleClick.dimensions),
  }))

  !(function(a9, a, p, s, t, A, g) {
    if (a[a9]) {
      return
    }

    function q(c, r) {
      a[a9]._Q.push([c, r])
    }

    a[a9] = {
      init: function() {
        q('i', arguments)
      },
      fetchBids: function() {
        q('f', arguments)
      },
      setDisplayBids: function() {},
      targetingKeys: function() {
        return []
      },
      _Q: [],
    }
    A = p.createElement(s)
    A.async = !0
    A.src = t
    g = p.getElementsByTagName(s)[0]
    g.parentNode.insertBefore(A, g)
  })('apstag', window, document, 'script', '//c.amazon-adsystem.com/aax2/apstag.js')

  // initialize apstag and have apstag set bids on the googletag slots when they are returned to the page
  apstag.init({
    pubID: APS_PUBLISHER_ID,
    adServer: 'googletag',
    videoAdServer: 'DFP',
    bidTimeout: 2e3,
  })

  // request the bids for the googletag slots
  apstag.fetchBids(
    {
      slots,
    },
    function(bids) {
      // set apstag bids, then trigger the first request to DFP
      googletag.cmd.push(function() {
        apstag.setDisplayBids()
        googletag.pubads().refresh()
      })
    }
  )
}

export default initAmazonHeaderBidder



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/ads/initAmazonHeaderBidder.js